var map = {
	".": 219,
	"./": 219,
	"./Addresses": 11,
	"./Addresses.js": 11,
	"./Api": 21,
	"./Api/": 21,
	"./Api/common": 103,
	"./Api/common.js": 103,
	"./Api/index": 21,
	"./Api/index.js": 21,
	"./Api/prices": 265,
	"./Api/prices.js": 265,
	"./Api/referrals": 241,
	"./Api/referrals.js": 241,
	"./App": 289,
	"./App.css": 516,
	"./App.js": 289,
	"./AppOrder.css": 517,
	"./Constants": 59,
	"./Constants.js": 59,
	"./Font.css": 518,
	"./Footer": 69,
	"./Footer.css": 519,
	"./Footer.js": 69,
	"./Helpers": 2,
	"./Helpers.js": 2,
	"./Input.css": 520,
	"./Shared.css": 521,
	"./__tests__/Helpers": 522,
	"./__tests__/Helpers.js": 522,
	"./_development.Addresses": 523,
	"./_development.Addresses.js": 523,
	"./abis/ANZOR": 524,
	"./abis/ANZOR.json": 524,
	"./abis/EQUITY": 525,
	"./abis/EQUITY.json": 525,
	"./abis/ERC721": 297,
	"./abis/ERC721.json": 297,
	"./abis/EqualOrderNft": 526,
	"./abis/EqualOrderNft.json": 526,
	"./abis/EqualOrderSale": 527,
	"./abis/EqualOrderSale.json": 527,
	"./abis/EqualOrderStaking": 528,
	"./abis/EqualOrderStaking.json": 528,
	"./abis/EqualizerV2Voter": 529,
	"./abis/EqualizerV2Voter.json": 529,
	"./abis/EquityFarm": 104,
	"./abis/EquityFarm.json": 104,
	"./abis/EquityManager": 111,
	"./abis/EquityManager.json": 111,
	"./abis/EquityToken": 298,
	"./abis/EquityToken.json": 298,
	"./abis/InfoSupply": 291,
	"./abis/InfoSupply.json": 291,
	"./abis/MintableBaseToken": 530,
	"./abis/MintableBaseToken.json": 530,
	"./abis/OrderBook": 97,
	"./abis/OrderBook.json": 97,
	"./abis/OrderBookReader": 299,
	"./abis/OrderBookReader.json": 299,
	"./abis/PositionManager": 290,
	"./abis/PositionManager.json": 290,
	"./abis/PositionRouter": 102,
	"./abis/PositionRouter.json": 102,
	"./abis/Reader": 64,
	"./abis/Reader.json": 64,
	"./abis/ReferralStorage": 162,
	"./abis/ReferralStorage.json": 162,
	"./abis/RewardReader": 112,
	"./abis/RewardReader.json": 112,
	"./abis/RewardRouter": 88,
	"./abis/RewardRouter.json": 88,
	"./abis/RewardTracker": 177,
	"./abis/RewardTracker.json": 177,
	"./abis/Router": 157,
	"./abis/Router.json": 157,
	"./abis/Token": 45,
	"./abis/Token.json": 45,
	"./abis/UniPool": 195,
	"./abis/UniPool.json": 195,
	"./abis/UniswapV2": 531,
	"./abis/UniswapV2.json": 531,
	"./abis/Vault": 81,
	"./abis/Vault.json": 81,
	"./abis/VaultReader": 292,
	"./abis/VaultReader.json": 292,
	"./abis/VeEqual": 390,
	"./abis/VeEqual.json": 390,
	"./abis/Vester": 131,
	"./abis/Vester.json": 131,
	"./abis/WETH": 242,
	"./abis/WETH.json": 242,
	"./abis/YieldFarm": 532,
	"./abis/YieldFarm.json": 532,
	"./abis/YieldToken": 533,
	"./abis/YieldToken.json": 533,
	"./components/APRLabel/APRLabel": 398,
	"./components/APRLabel/APRLabel.js": 398,
	"./components/AddressDropdown/AddressDropdown": 300,
	"./components/AddressDropdown/AddressDropdown.css": 534,
	"./components/AddressDropdown/AddressDropdown.js": 300,
	"./components/BlueWaves/BlueWaves": 305,
	"./components/BlueWaves/BlueWaves.css": 543,
	"./components/BlueWaves/BlueWaves.js": 305,
	"./components/BuyInputSection/BuyInputSection": 179,
	"./components/BuyInputSection/BuyInputSection.css": 544,
	"./components/BuyInputSection/BuyInputSection.js": 179,
	"./components/Checkbox/Checkbox": 58,
	"./components/Checkbox/Checkbox.css": 545,
	"./components/Checkbox/Checkbox.js": 58,
	"./components/Common/Button": 306,
	"./components/Common/Button.css": 546,
	"./components/Common/Button.js": 306,
	"./components/Common/Card": 547,
	"./components/Common/Card.css": 549,
	"./components/Common/Card.js": 547,
	"./components/Common/Loader": 550,
	"./components/Common/Loader.css": 551,
	"./components/Common/Loader.js": 550,
	"./components/Common/SEO": 116,
	"./components/Common/SEO.js": 116,
	"./components/Equity/EquitySwap": 307,
	"./components/Equity/EquitySwap.css": 555,
	"./components/Equity/EquitySwap.js": 307,
	"./components/EventToast/AnnouncementIcon": 312,
	"./components/EventToast/AnnouncementIcon.js": 312,
	"./components/EventToast/EventToast": 313,
	"./components/EventToast/EventToast.css": 557,
	"./components/EventToast/EventToast.js": 313,
	"./components/EventToast/EventToastContainer": 314,
	"./components/EventToast/EventToastContainer.js": 314,
	"./components/EventToast/useEventToast": 315,
	"./components/EventToast/useEventToast.js": 315,
	"./components/Exchange/ChartTokenSelector": 317,
	"./components/Exchange/ChartTokenSelector.css": 561,
	"./components/Exchange/ChartTokenSelector.js": 317,
	"./components/Exchange/ConfirmationBox": 318,
	"./components/Exchange/ConfirmationBox.js": 318,
	"./components/Exchange/ExchangeInfoRow": 60,
	"./components/Exchange/ExchangeInfoRow.js": 60,
	"./components/Exchange/ExchangeTVChart": 243,
	"./components/Exchange/ExchangeTVChart.js": 243,
	"./components/Exchange/ExchangeWalletTokens": 319,
	"./components/Exchange/ExchangeWalletTokens.css": 562,
	"./components/Exchange/ExchangeWalletTokens.js": 319,
	"./components/Exchange/OrderEditor": 320,
	"./components/Exchange/OrderEditor.js": 320,
	"./components/Exchange/OrdersList": 197,
	"./components/Exchange/OrdersList.css": 563,
	"./components/Exchange/OrdersList.js": 197,
	"./components/Exchange/OrdersToa": 198,
	"./components/Exchange/OrdersToa.css": 564,
	"./components/Exchange/OrdersToa.js": 198,
	"./components/Exchange/PositionEditor": 321,
	"./components/Exchange/PositionEditor.js": 321,
	"./components/Exchange/PositionSeller": 322,
	"./components/Exchange/PositionSeller.js": 322,
	"./components/Exchange/PositionsList": 199,
	"./components/Exchange/PositionsList.js": 199,
	"./components/Exchange/SwapBox": 323,
	"./components/Exchange/SwapBox.js": 323,
	"./components/Exchange/TokenSelector": 146,
	"./components/Exchange/TokenSelector.css": 554,
	"./components/Exchange/TokenSelector.js": 146,
	"./components/Exchange/TradeHistory": 200,
	"./components/Exchange/TradeHistory.css": 565,
	"./components/Exchange/TradeHistory.js": 200,
	"./components/InputSection/InputSection": 566,
	"./components/InputSection/InputSection.css": 567,
	"./components/InputSection/InputSection.js": 566,
	"./components/Modal/Modal": 50,
	"./components/Modal/Modal.css": 553,
	"./components/Modal/Modal.js": 50,
	"./components/NetworkSelector/Indicator.svg": 935,
	"./components/NetworkSelector/NetworkSelector": 244,
	"./components/NetworkSelector/NetworkSelector.css": 568,
	"./components/NetworkSelector/NetworkSelector.js": 244,
	"./components/Overlay/Overlay": 712,
	"./components/Overlay/Overlay.css": 713,
	"./components/Overlay/Overlay.js": 712,
	"./components/Radio/Radio": 714,
	"./components/Radio/Radio.css": 715,
	"./components/Radio/Radio.js": 714,
	"./components/Tab/Tab": 93,
	"./components/Tab/Tab.css": 552,
	"./components/Tab/Tab.js": 93,
	"./components/TokenCard/TokenCard": 201,
	"./components/TokenCard/TokenCard.css": 939,
	"./components/TokenCard/TokenCard.js": 201,
	"./components/Tooltip/Tooltip": 29,
	"./components/Tooltip/Tooltip.css": 548,
	"./components/Tooltip/Tooltip.js": 29,
	"./components/WarningBanner/WarningBanner": 342,
	"./components/WarningBanner/WarningBanner.css": 716,
	"./components/WarningBanner/WarningBanner.js": 342,
	"./config/events": 316,
	"./config/events.js": 316,
	"./contexts/RefreshContext": 155,
	"./contexts/RefreshContext/": 155,
	"./contexts/RefreshContext/RefreshContextProvider": 223,
	"./contexts/RefreshContext/RefreshContextProvider.tsx": 223,
	"./contexts/RefreshContext/index": 155,
	"./contexts/RefreshContext/index.ts": 155,
	"./data/Fees": 343,
	"./data/Fees.js": 343,
	"./data/Tokens": 33,
	"./data/Tokens.js": 33,
	"./fonts/Inter-Bold.ttf": 940,
	"./fonts/Inter.ttf": 941,
	"./fonts/etna.otf": 942,
	"./fonts/relative/relative-bold-pro.eot": 943,
	"./fonts/relative/relative-bold-pro.ttf": 944,
	"./fonts/relative/relative-bold-pro.woff": 945,
	"./fonts/relative/relative-bold-pro.woff2": 946,
	"./fonts/relative/relative-book-pro.eot": 947,
	"./fonts/relative/relative-book-pro.ttf": 948,
	"./fonts/relative/relative-book-pro.woff": 949,
	"./fonts/relative/relative-book-pro.woff2": 950,
	"./fonts/relative/relative-faux-book-pro.eot": 951,
	"./fonts/relative/relative-faux-book-pro.ttf": 952,
	"./fonts/relative/relative-faux-book-pro.woff": 953,
	"./fonts/relative/relative-faux-book-pro.woff2": 954,
	"./fonts/relative/relative-medium-pro.eot": 955,
	"./fonts/relative/relative-medium-pro.ttf": 956,
	"./fonts/relative/relative-medium-pro.woff": 957,
	"./fonts/relative/relative-medium-pro.woff2": 958,
	"./fonts/relative/relative-mono-10-pitch-pro.eot": 959,
	"./fonts/relative/relative-mono-10-pitch-pro.ttf": 960,
	"./fonts/relative/relative-mono-10-pitch-pro.woff": 961,
	"./fonts/relative/relative-mono-10-pitch-pro.woff2": 962,
	"./hooks/useDebounce": 717,
	"./hooks/useDebounce.ts": 717,
	"./hooks/useIsWindowVisible": 718,
	"./hooks/useIsWindowVisible.ts": 718,
	"./hooks/useLockBodyScroll": 308,
	"./hooks/useLockBodyScroll.js": 308,
	"./hooks/useRefresh": 719,
	"./hooks/useRefresh.ts": 719,
	"./hooks/useRouteQuery": 344,
	"./hooks/useRouteQuery.js": 344,
	"./img/ANZOR_logo.svg": 569,
	"./img/Anyswap.png": 570,
	"./img/Anyswap.svg": 571,
	"./img/Artwork.svg": 572,
	"./img/Artwork_gmx.svg": 573,
	"./img/Banxa.png": 574,
	"./img/DROP_DOWN.svg": 309,
	"./img/Equity_iconlogo.svg": 137,
	"./img/Hop.png": 575,
	"./img/Hop.svg": 576,
	"./img/Hop_dark.png": 577,
	"./img/Hop_dark.svg": 578,
	"./img/MVX_logo.svg": 579,
	"./img/Multichain.png": 327,
	"./img/Synapse.png": 580,
	"./img/Synapse.svg": 328,
	"./img/anzor-logo.png": 581,
	"./img/anzor.png": 582,
	"./img/banner-avt.9083d854.png": 583,
	"./img/banner-bg-small.f86fb377.png": 584,
	"./img/banner-bg.5241de9f.png": 585,
	"./img/banner-vector.d1966b5c.png": 586,
	"./img/bg.50b2dacb.png": 587,
	"./img/binance.png": 588,
	"./img/bscscan.png": 589,
	"./img/btn_big_arbitrum.png": 590,
	"./img/btn_big_avalanche.png": 591,
	"./img/btn_big_bsc.png": 592,
	"./img/btn_big_new.svg": 593,
	"./img/btn_big_purchasegmx.png": 594,
	"./img/btn_big_purchasegmx.svg": 595,
	"./img/btn_big_purchasemvx.svg": 596,
	"./img/buy_gmx.svg": 597,
	"./img/buy_gmx_bond.svg": 598,
	"./img/buy_transfer_eth.svg": 599,
	"./img/cbridgev2.svg": 455,
	"./img/chainlink.svg": 396,
	"./img/chart.png": 600,
	"./img/coinbaseWallet.png": 329,
	"./img/coingecko.png": 601,
	"./img/cross.svg": 602,
	"./img/dollar.png": 603,
	"./img/dropdown-ic.b57edcbf.svg": 604,
	"./img/earnlogo.svg": 270,
	"./img/elp-logo-black-min.png": 392,
	"./img/equal-logo.svg": 605,
	"./img/equalizer-logo-big.png": 606,
	"./img/equalswap-logo.png": 330,
	"./img/equity-logo-text.png": 331,
	"./img/equity-logo.png": 607,
	"./img/equity.png": 608,
	"./img/equity_icon.svg": 609,
	"./img/footerpolygon.svg": 610,
	"./img/footerpolygonnew.svg": 611,
	"./img/ftm.5c12026b.svg": 612,
	"./img/glp_icon.svg": 613,
	"./img/gmx-logo-final-white-small.png": 614,
	"./img/gmx-logo-final-white.png": 615,
	"./img/gmx-logo-final.png": 616,
	"./img/gmx-logo-glow.png": 617,
	"./img/gmx_logo.svg": 618,
	"./img/graphite-01.png": 619,
	"./img/home-banner-img.png": 620,
	"./img/home-bg-old.png": 621,
	"./img/home-bg.jpg": 622,
	"./img/home-bg.png": 623,
	"./img/ic-communityproject.svg": 624,
	"./img/ic-info.20267414.svg": 625,
	"./img/ic-mint.dbcd686f.svg": 626,
	"./img/ic_aave_24.svg": 404,
	"./img/ic_aave_40.svg": 432,
	"./img/ic_anzor_40.png": 627,
	"./img/ic_anzor_40.svg": 433,
	"./img/ic_arbitrum_16.svg": 628,
	"./img/ic_arbitrum_24.svg": 405,
	"./img/ic_arbitrum_96.svg": 629,
	"./img/ic_arbitrum_hover_16.svg": 630,
	"./img/ic_avalanche_16.svg": 631,
	"./img/ic_avalanche_24.svg": 406,
	"./img/ic_avalanche_96.svg": 632,
	"./img/ic_avax_24.svg": 407,
	"./img/ic_avax_30.svg": 633,
	"./img/ic_avax_40.svg": 434,
	"./img/ic_banxa.svg": 634,
	"./img/ic_binance_logo.svg": 635,
	"./img/ic_bsc.svg": 636,
	"./img/ic_bsc_96.svg": 637,
	"./img/ic_btc_24.svg": 408,
	"./img/ic_btc_40.svg": 435,
	"./img/ic_busd_24.svg": 409,
	"./img/ic_buy_equity.svg": 332,
	"./img/ic_buy_glp.svg": 638,
	"./img/ic_buy_mvlp.svg": 639,
	"./img/ic_cash.png": 640,
	"./img/ic_cash.svg": 641,
	"./img/ic_coingecko_16.svg": 642,
	"./img/ic_coingecko_hover_16.svg": 311,
	"./img/ic_convert_down.svg": 310,
	"./img/ic_copy_16.svg": 302,
	"./img/ic_cost.svg": 643,
	"./img/ic_costnew.svg": 644,
	"./img/ic_dai_24.svg": 410,
	"./img/ic_dai_40.svg": 436,
	"./img/ic_discord.svg": 295,
	"./img/ic_equity_24.svg": 411,
	"./img/ic_equity_40.png": 645,
	"./img/ic_equity_40.svg": 437,
	"./img/ic_eth_24.svg": 412,
	"./img/ic_eth_40.svg": 268,
	"./img/ic_fantom_16.svg": 646,
	"./img/ic_fantom_24.svg": 413,
	"./img/ic_fantom_96.svg": 647,
	"./img/ic_frax_24.svg": 414,
	"./img/ic_frax_40.svg": 438,
	"./img/ic_ftm_24.svg": 415,
	"./img/ic_ftm_30.svg": 648,
	"./img/ic_ftm_40.svg": 439,
	"./img/ic_gitbook.svg": 296,
	"./img/ic_github.svg": 394,
	"./img/ic_glp_24.svg": 416,
	"./img/ic_glp_40.svg": 440,
	"./img/ic_glp_custom.svg": 649,
	"./img/ic_gmx.svg": 650,
	"./img/ic_gmx_24.svg": 417,
	"./img/ic_gmx_30.svg": 651,
	"./img/ic_gmx_40.svg": 441,
	"./img/ic_gmx_64.svg": 652,
	"./img/ic_gmx_arbitrum.svg": 653,
	"./img/ic_gmx_avax.svg": 654,
	"./img/ic_gmx_big.svg": 655,
	"./img/ic_gmx_custom.svg": 656,
	"./img/ic_gmx_footer.svg": 657,
	"./img/ic_hop.svg": 658,
	"./img/ic_info.svg": 659,
	"./img/ic_link_24.svg": 418,
	"./img/ic_link_40.svg": 442,
	"./img/ic_liq.svg": 660,
	"./img/ic_liquidity.svg": 661,
	"./img/ic_matic_16.svg": 662,
	"./img/ic_matic_16new.svg": 663,
	"./img/ic_matic_24.svg": 419,
	"./img/ic_matic_40.svg": 443,
	"./img/ic_medium.svg": 395,
	"./img/ic_metamask_16.svg": 664,
	"./img/ic_metamask_hover_16.svg": 196,
	"./img/ic_mim_24.svg": 420,
	"./img/ic_mim_40.svg": 444,
	"./img/ic_multiswap.svg": 665,
	"./img/ic_mvlp_24.svg": 421,
	"./img/ic_mvlp_40.png": 666,
	"./img/ic_mvlp_40.svg": 445,
	"./img/ic_mvx_40.png": 667,
	"./img/ic_mvx_40.svg": 446,
	"./img/ic_new_link_16.svg": 301,
	"./img/ic_olympus.svg": 668,
	"./img/ic_olympus_arbitrum.svg": 669,
	"./img/ic_polygon.svg": 670,
	"./img/ic_polygon_16.svg": 671,
	"./img/ic_polygon_24.svg": 422,
	"./img/ic_selector_dropdowns.svg": 205,
	"./img/ic_settings_16.svg": 303,
	"./img/ic_sign in_16.svg": 672,
	"./img/ic_sign_out_16.svg": 304,
	"./img/ic_simplenew.svg": 673,
	"./img/ic_simpleswaps.svg": 674,
	"./img/ic_stats.svg": 675,
	"./img/ic_stats_big.svg": 333,
	"./img/ic_synapse.svg": 676,
	"./img/ic_telegram.svg": 393,
	"./img/ic_tether_24.svg": 423,
	"./img/ic_tokens.svg": 334,
	"./img/ic_totaluser.svg": 677,
	"./img/ic_trading.svg": 678,
	"./img/ic_transfer_avax.svg": 679,
	"./img/ic_twitter.svg": 294,
	"./img/ic_uni_24.svg": 424,
	"./img/ic_uni_40.svg": 447,
	"./img/ic_usdc.e_24.svg": 425,
	"./img/ic_usdc.e_40.svg": 448,
	"./img/ic_usdc_24.svg": 426,
	"./img/ic_usdc_40.svg": 449,
	"./img/ic_usdt_24.svg": 427,
	"./img/ic_usdt_40.svg": 450,
	"./img/ic_wallet_24.svg": 238,
	"./img/ic_wavax_24.svg": 428,
	"./img/ic_wavax_40.svg": 451,
	"./img/ic_weth_24.svg": 429,
	"./img/ic_weth_40.svg": 452,
	"./img/ic_wftm_24.svg": 430,
	"./img/ic_wftm_40.svg": 453,
	"./img/ic_wmatic_24.svg": 431,
	"./img/ic_wmatic_40.svg": 454,
	"./img/lg_arbitrum.svg": 680,
	"./img/lg_fantom.svg": 456,
	"./img/lg_near.svg": 681,
	"./img/lg_polygon.svg": 682,
	"./img/link-green.8997d55b.svg": 683,
	"./img/link-white.5228d68c.svg": 684,
	"./img/linktree_white.svg": 397,
	"./img/liquidation.png": 335,
	"./img/logo-equal.png": 167,
	"./img/logo-equity.png": 94,
	"./img/logo-fantom.png": 73,
	"./img/logo_ANZOR.svg": 685,
	"./img/logo_ANZOR_small.svg": 686,
	"./img/logo_MVX.svg": 687,
	"./img/long.svg": 324,
	"./img/man.png": 688,
	"./img/manage-swaps.png": 689,
	"./img/metamask-text.svg": 690,
	"./img/metamask.png": 691,
	"./img/money.png": 692,
	"./img/mum1.826066ac.png": 693,
	"./img/mum2.19e61eee.png": 694,
	"./img/mvlp.png": 695,
	"./img/mvx.png": 696,
	"./img/mvxheader.svg": 697,
	"./img/nfts/equal-footer-banner-left.png": 698,
	"./img/nfts/equal-footer-banner-right.png": 699,
	"./img/nfts/equal-nft-banner-avatar.png": 700,
	"./img/open-interest.png": 701,
	"./img/openinterest.png": 336,
	"./img/openinterest.svg": 702,
	"./img/page-not-found.svg": 703,
	"./img/placeholder.svg": 704,
	"./img/save-costs.png": 337,
	"./img/short.svg": 325,
	"./img/simple-swaps.png": 338,
	"./img/solid_background_3.png": 705,
	"./img/swap.svg": 326,
	"./img/total-users.png": 339,
	"./img/total-volume.png": 340,
	"./img/totalusers.svg": 706,
	"./img/totalvolume.png": 707,
	"./img/trading.png": 708,
	"./img/wallet-connect-text.svg": 709,
	"./img/walletconnect-circle-blue.svg": 341,
	"./img/wave-01.png": 710,
	"./img/wave-02.png": 711,
	"./img/xpollinate.svg": 457,
	"./index": 219,
	"./index.css": 511,
	"./index.js": 219,
	"./logo.svg": 963,
	"./react-app-env.d": 720,
	"./react-app-env.d.ts": 720,
	"./reportWebVitals": 345,
	"./reportWebVitals.js": 345,
	"./views/Actions/Actions": 246,
	"./views/Actions/Actions.css": 721,
	"./views/Actions/Actions.js": 246,
	"./views/BeginAccountTransfer/BeginAccountTransfer": 346,
	"./views/BeginAccountTransfer/BeginAccountTransfer.css": 723,
	"./views/BeginAccountTransfer/BeginAccountTransfer.js": 346,
	"./views/Buy/Buy": 347,
	"./views/Buy/Buy.css": 724,
	"./views/Buy/Buy.js": 347,
	"./views/BuyEQUAL/BuyEQUAL": 348,
	"./views/BuyEQUAL/BuyEQUAL.css": 725,
	"./views/BuyEQUAL/BuyEQUAL.js": 348,
	"./views/BuyEquity/BuyEquity": 349,
	"./views/BuyEquity/BuyEquity.css": 726,
	"./views/BuyEquity/BuyEquity.js": 349,
	"./views/ClaimEsEqual/ClaimEsEqual": 350,
	"./views/ClaimEsEqual/ClaimEsEqual.css": 964,
	"./views/ClaimEsEqual/ClaimEsEqual.js": 350,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer": 351,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer.css": 727,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer.js": 351,
	"./views/Dashboard/AssetDropdown": 160,
	"./views/Dashboard/AssetDropdown.css": 556,
	"./views/Dashboard/AssetDropdown.js": 160,
	"./views/Dashboard/Dashboard": 352,
	"./views/Dashboard/Dashboard.css": 1197,
	"./views/Dashboard/Dashboard.js": 352,
	"./views/Dashboard/DashboardV2": 353,
	"./views/Dashboard/DashboardV2.css": 728,
	"./views/Dashboard/DashboardV2.js": 353,
	"./views/Debug/Debug": 354,
	"./views/Debug/Debug.js": 354,
	"./views/Ecosystem/Ecosystem": 355,
	"./views/Ecosystem/Ecosystem.css": 835,
	"./views/Ecosystem/Ecosystem.js": 355,
	"./views/Exchange/Exchange": 178,
	"./views/Exchange/Exchange.css": 722,
	"./views/Exchange/Exchange.js": 178,
	"./views/FarmEquity/FarmEquity": 356,
	"./views/FarmEquity/FarmEquity.css": 836,
	"./views/FarmEquity/FarmEquity.js": 356,
	"./views/Home/Home": 209,
	"./views/Home/Home.css": 837,
	"./views/Home/Home.js": 209,
	"./views/NftWallet/NftWallet": 357,
	"./views/NftWallet/NftWallet.css": 838,
	"./views/NftWallet/NftWallet.js": 357,
	"./views/OrdersOverview/OrdersOverview": 358,
	"./views/OrdersOverview/OrdersOverview.css": 839,
	"./views/OrdersOverview/OrdersOverview.js": 358,
	"./views/PositionsOverview/PositionsOverview": 359,
	"./views/PositionsOverview/PositionsOverview.css": 840,
	"./views/PositionsOverview/PositionsOverview.js": 359,
	"./views/SellEquity/SellEquity": 360,
	"./views/SellEquity/SellEquity.css": 1198,
	"./views/SellEquity/SellEquity.js": 360,
	"./views/Stake/Stake": 841,
	"./views/Stake/Stake.css": 1199,
	"./views/Stake/Stake.js": 841,
	"./views/Stake/StakeV2": 361,
	"./views/Stake/StakeV2.css": 842,
	"./views/Stake/StakeV2.js": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;